const CHANNEL_NAME = 'gc-slides-sync'

export function createSlideSync(onSlideChange: (index: number) => void) {
  const channel = new BroadcastChannel(CHANNEL_NAME)
  let receiving = false

  channel.onmessage = (event) => {
    if (event.data?.type === 'slide-change') {
      receiving = true
      onSlideChange(event.data.index)
      // Reset after a tick so the resulting engine callback sees receiving=true
      setTimeout(() => { receiving = false }, 50)
    }
  }

  function broadcast(index: number) {
    // Don't re-broadcast if this change came from an external broadcast
    if (receiving) return
    channel.postMessage({ type: 'slide-change', index })
  }

  function close() {
    channel.close()
  }

  return { broadcast, close }
}
